import {API_ROOT} from "../baseUrls";
import {buildFormData} from "../state/actions/actionUtils";
import * as types from "../state/actions/actionTypes";

export function rotateImage(mindfileId, uploadId, callback = (data) => {}) {
  return function (dispatch, getState) {
    fetch(`${API_ROOT}/mindfiles/${mindfileId}/uploads/rotate/${uploadId}`, {
      method: "POST",
      credentials: "include",
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({
          type: types.GET_MINDFILE_ITEM,
          payload: data
        });
        return data;
      })
      .then(data => callback(data))
      .catch(error => {
        console.error(error);
      })
  };
}

export function shareFileByEmail({mindfileId, itemId, authenticityToken, to, message}) {

  const promise = fetch(
    `${API_ROOT}/mindfiles/${mindfileId}/items/${itemId}/share`,
    {
      method: "POST",
      credentials: "include",
      body: buildFormData({to: to, message: message}),
      headers: {'X-CSRF-Token': authenticityToken},
    }
  )
  .then(resp => resp.json())

  return promise;
}
